import { ProductSwitcher as SharedProductSwitcher } from '@podstack/ui';

interface ProductSwitcherProps {
  subtitle: string;
  compact?: boolean;
  className?: string;
}

const ProductSwitcher: React.FC<ProductSwitcherProps> = ({ subtitle, compact = false, className }) => {
  return (
    <SharedProductSwitcher
      currentKey="trainpods"
      subtitle={subtitle}
      compact={compact}
      className={className}
    />
  );
};

export default ProductSwitcher;
